import { createApi } from "redux-future-middleware";
import { stringify } from "query-string";
import { requestApi } from "core/api";
import * as model from "./model";
import * as types from "./types";

export const getInsiders = createApi({
  name: types.GET_INSIDERS,
  request: ({ filter, page, ordering }) => {
    const encodedFilter = encodeURIComponent(filter);

    return requestApi({
      path: `/insiders/professionals/?${stringify(
        {
          filter: filter && encodedFilter,
          page,
          ordering
        },
        { encode: false }
      )}`,
      method: "GET"
    });
  },
  merge: ({ page }, currentState, nextState) =>
    !page ? nextState : model.mergeSlots(currentState, nextState)
});

export const getFilters = createApi({
  name: types.GET_FILTERS,
  request: () =>
    requestApi({
      path: "/insiders/filters/",
      method: "GET"
    })
});
export const getInsider = createApi({
  name: types.GET_INSIDER,
  request: ({ id }) =>
    requestApi({
      path: `/insiders/professionals/${id}/`,
      method: "GET"
    })
});
export const getSuggestedInsiders = createApi({
  name: types.GET_SUGGESTED_INSIDERS,
  request: () =>
    requestApi({
      path: "/insiders/professionals/suggested/",
      method: "GET"
    })
});

export const getCallObjectives = createApi({
  name: types.GET_CALL_OBJECTIVES,
  request: () =>
    requestApi({
      path: "/insiders/call-objectives/",
      method: "GET"
    })
});

export const getCallObjective = createApi({
  name: types.GET_CALL_OBJECTIVE,
  request: ({ id }) =>
    requestApi({
      path: `/insiders/call-objectives/${id}/`,
      method: "GET"
    })
});

export const getAvailableTime = createApi({
  name: types.GET_AVAILABLE_TIME,
  request: ({ id, next }) =>
    requestApi({
      path:
        (next && next.replace(/^http:/, "https:")) ||
        `/insiders/timetable/?insider_id=${id}&page=1`,
      method: "GET"
    }),
  merge: ({ next }, currentState, nextState) =>
    !next ? nextState : model.mergeSlots(currentState, nextState)
});

export const askSuggestion = createApi({
  name: types.ASK_SUGGESTION,
  request: () =>
    requestApi({
      path: "/insiders/professionals/ask-for-suggestion/",
      method: "GET"
    })
});

export const getAllInsidersReviews = createApi({
  name: types.GET_ALL_INSIDERS_REVIEWS,
  request: () =>
    requestApi({
      path: "/insiders/feedback/all-other-part-review",
      method: "GET"
    })
});

export const getAverageInsiderRating = createApi({
  name: types.GET_AVERAGE_INSIDER_RATING,
  request: () =>
    requestApi({
      path: "/insiders/feedback/global-rate/",
      method: "GET"
    })
});

export const getPositions = createApi({
  name: types.GET_POSITIONS,
  request: () =>
    requestApi({
      path: "/insiders/positions/",
      method: "GET"
    })
});

export const addPositions = createApi({
  name: types.ADD_POSITIONS,
  request: ({ body }) =>
    requestApi({
      path: "/insiders/positions/",
      method: "POST",
      body
    })
});

export const deletePosition = createApi({
  name: types.DELETE_POSITION,
  request: id =>
    requestApi({
      path: `/insiders/positions/${id}/`,
      method: "DELETE"
    })
});

export const getCountries = createApi({
  name: types.GET_COUNTRIES,
  request: () =>
    requestApi({
      path: "/insiders/cities-countries",
      method: "GET"
    })
});

export const getCities = createApi({
  name: types.GET_CITIES,
  request: ({ body }) =>
    requestApi({
      path: "/insiders/cities-countries",
      method: "GET",
      body
    })
});

export const getAvailabilities = createApi({
  name: types.GET_AVAILABILITIES,
  request: () =>
    requestApi({
      path: "/insiders/availability/",
      method: "GET"
    })
});

export const getAvailability = createApi({
  name: types.GET_AVAILABILITY,
  request: id =>
    requestApi({
      path: `/insiders/availability/${id}`,
      method: "GET"
    })
});

export const addAvailability = createApi({
  name: types.ADD_AVAILABILITY,
  request: ({ body }) =>
    requestApi({
      path: `/insiders/availability/`,
      method: "POST",
      body
    })
});

export const deleteAvailability = createApi({
  name: types.DELETE_AVAILABILITY,
  request: id =>
    requestApi({
      path: `/insiders/availability/${id}/`,
      method: "DELETE"
    })
});



// WEBPACK FOOTER //
// ./src/modules/insiders/api.js